import { render, staticRenderFns } from "./ShoulderSelect.vue?vue&type=template&id=3729a8be&"
import script from "./ShoulderSelect.vue?vue&type=script&lang=js&"
export * from "./ShoulderSelect.vue?vue&type=script&lang=js&"
import style0 from "./ShoulderSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports